import * as actionTypes from "./actionTypes";

export const onPOST = (param, routeToCall, callback = () => {}) => {
  return {
    param,
    routeToCall,
    type: actionTypes.LOAN_POST,
    callback,
  };
};


export const onGET = (routeToCall, callback = () => {}) => {
  return {
    routeToCall,
    type: actionTypes.LOAN_GET,
    callback,
  };
};


export const onDummy = (routeToCall, callback = () => {}) => {
  return {
    routeToCall,
    type: actionTypes.LOAN_DUMMY,
    callback,
  };
};

export const onDummyPost = (param, routeToCall, callback = () => {}) => {
  return {
    param,
    routeToCall,
    type: actionTypes.LOAN_DUMMY_POST,
    callback,
  };
};

